import React from 'react';
import './styles/section-news-and-blogs.css'

const SectionNewsAndBlogs = () => {
  return (
    <section className='section-news-and-blogs comman_sec'>
        <div className='header-navbar-wrapper'>
                                <ul className="nav navbar-nav">
                                    <li><a href='/'>News & Blogs</a></li>
                                </ul>
                            </div>
    </section>
  )
}

export default SectionNewsAndBlogs